import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DatePickerBox from '../../../component/DatePickerBox';
import BreadCrumb from '../../../component/BreadCrumb';
import TimePickerBox from '../../../component/TimePickerBox';
import SelectionBox from '../../../component/SelectionBox';
import { BlueBorderButtonBox, RedBorderButtonBox } from '../../../component/buttons/CustomButtonBox';
import SearchButtonBox from '../../../component/buttons/SearchButtonBox';
import { CODE_GROUP_ID } from '../../../constant/Constant';
import { VIEW_SEMESTER_ENROLMENT_MANAGEMENT } from '../../../constant/ViewConstant';
import {
    actionSearch,
    actionSaveTerm,
    actionSaveNotice,
    handleSemesterId,
} from '../../../module/body/semester/SemesterEnrolmentManagementModule';
import AuthenticationUtil from '../../../util/AuthenticationUtil';
import CodeUtil from '../../../util/CodeUtil';
import SessionStorageUtil from '../../../util/SessionStorageUtil';
import { date2Millis, millis2Date } from '../../../util/TimeTableUtil';
import TextEditor from '../../../component/editor/TextEditor';
import TextViewer from '../../../component/editor/TextViewer';

import PopupRef from '../../../component/PopupRef';
import NullCheckUtil from '../../../util/NullCheckUtil';
import SemesterUtil from '../../../util/SemesterUtil';
import { Switch } from '@material-ui/core';

const ConditionArea = ({ mainUniversityCd }) => {
    const [semesterId, setSemesterId] = useState('');
    const dispatch = useDispatch();

    useEffect(() => {
        setSemesterId(SessionStorageUtil.getCurrentSemesterId());
    }, []);

    useEffect(() => {
        if (semesterId) {
            dispatch(
                actionSearch({
                    params: {
                        semesterId,
                        mainUniversityCd,
                    },
                }),
            );
        }

        dispatch(handleSemesterId(semesterId));
    }, [semesterId]);

    const onClickSearch = () => {
        dispatch(
            actionSearch({
                params: {
                    semesterId,
                    mainUniversityCd,
                },
            }),
        );
    };

    const handleChangeSemeterId = (semesterId) => {
        setSemesterId(semesterId);
        dispatch(handleSemesterId(semesterId));
    };

    return (
        <>
            <div className='con-form-wrap'>
                <div className='board-inner'>
                    <div className='board-row'>
                        <div className='lec-check-box'>
                            <div className='form-box-container'>
                                <SelectionBox
                                    title='학기'
                                    value={semesterId}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.SEMESTER)}
                                    onChange={(e) => handleChangeSemeterId(e.target.value)}
                                    useAll={false}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                            </div>
                            <div className='lec-check-btn'>
                                <SearchButtonBox title='조회' onClick={onClickSearch} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const TermArea = ({ mainUniversityCd }) => {
    const { semesterInfo, semesterId } = useSelector((state) => state.semesterEnrolmentManagementState);
    const [enrolmentBgnDt, setEnrolmentBgnDt] = useState('');
    const [enrolmentEndDt, setEnrolmentEndDt] = useState('');
    const [enrolmentBgnTime, setEnrolmentBgnTime] = useState('');
    const [enrolmentEndTime, setEnrolmentEndTime] = useState('');

    const dispatch = useDispatch();
    const popupRef = useRef(null);

    useEffect(() => {
        if (semesterInfo?.enrolmentBgnDt && semesterInfo?.enrolmentEndDt) {
            let beginDt = semesterInfo.enrolmentBgnDt;
            let endDt = semesterInfo.enrolmentEndDt;
            setEnrolmentBgnDt(beginDt.substring(0, 4) + '-' + beginDt.substring(4, 6) + '-' + beginDt.substring(6, 8));
            setEnrolmentEndDt(endDt.substring(0, 4) + '-' + endDt.substring(4, 6) + '-' + endDt.substring(6, 8));
        }

        setEnrolmentBgnTime(semesterInfo?.enrolmentBgnTime);
        setEnrolmentEndTime(semesterInfo?.enrolmentEndTime);
    }, [semesterInfo]);

    const validateTermData = () => {
        if (
            NullCheckUtil.isEmpty(enrolmentBgnDt) &&
            NullCheckUtil.isEmpty(enrolmentEndDt) &&
            NullCheckUtil.isEmpty(enrolmentBgnTime) &&
            NullCheckUtil.isEmpty(enrolmentEndTime)
        ) {
            return true;
        }

        if (
            !NullCheckUtil.isEmpty(enrolmentBgnDt) &&
            !NullCheckUtil.isEmpty(enrolmentEndDt) &&
            !NullCheckUtil.isEmpty(enrolmentBgnTime) &&
            !NullCheckUtil.isEmpty(enrolmentEndTime)
        ) {
            if (new Date(enrolmentBgnDt) > new Date(enrolmentEndDt)) {
                popupRef.current.openAlert('수강신청 시작일자는 수강신청 종료일자보다 먼저여야 합니다.');
                return false;
            }
            if (Number(enrolmentBgnTime) >= Number(enrolmentEndTime)) {
                popupRef.current.openAlert('수강신청 시작시간은 수강신청 종료시간 보다 이전시간 이어야 합니다.');
                return false;
            }
            return true;
        } else {
            popupRef.current.openAlert('값을 입력하지 않은 항목이 존재합니다. 값을 입력해 주세요.');
            return false;
        }
    };

    const handleTimeInit = () => {
        setEnrolmentBgnDt('');
        setEnrolmentEndDt('');
        setEnrolmentBgnTime('');
        setEnrolmentEndTime('');
    };

    const handleConfirm = () => {
        if (validateTermData()) {
            dispatch(
                actionSaveTerm({
                    params: {
                        semesterId,
                        mainUniversityCd,
                        enrolmentBgnDt: enrolmentBgnDt.replace(/-/gi, ''),
                        enrolmentEndDt: enrolmentEndDt.replace(/-/gi, ''),
                        enrolmentBgnTime,
                        enrolmentEndTime,
                    },
                    callback: () => {
                        popupRef.current.openInfo('수강신청 기간이 저장 되었습니다.', () => {
                            return function () {};
                        });
                    },
                }),
            );
        }
    };

    return (
        <>
            <div className='con-tb-wrap border-bottom-line'>
                <div className='con-tb-title  '>
                    <h3>
                        대학별 수강신청 시간관리{' '}
                        {semesterId &&
                            mainUniversityCd &&
                            `(${CodeUtil.getCodeName(
                                CODE_GROUP_ID.USER_UNIVERSITY,
                                mainUniversityCd,
                            )} , ${SemesterUtil.convertSemesterNm(semesterId)})`}
                    </h3>
                </div>
                <div className='comment-box'>
                    <ul>
                        <li>해당학기의 대학별 수강신청 가능 기간을 설정합니다</li>
                        <li>초기화 버튼 누르고 저장하여야 초기화된 값이 저장됩니다.</li>
                        <li>대학별 수강신청 설정 기간동안에만 해당 대학의 강의 수강신청 및 변경이 가능합니다.</li>
                        <li>수강신청 기간을 지정하지 않으면, 해당 대학은 수강신청이 불가합니다.</li>
                    </ul>
                </div>

                <div className='form-box-container mt16'>
                    <div className='form-box-row multi-form'>
                        <DatePickerBox
                            title='수강신청 시작일자'
                            value={enrolmentBgnDt}
                            size='large'
                            onChange={(e) => setEnrolmentBgnDt(e.target.value)}
                        />
                        <DatePickerBox
                            title='수강신청 종료일자'
                            value={enrolmentEndDt}
                            size='large'
                            onChange={(e) => setEnrolmentEndDt(e.target.value)}
                        />
                        <TimePickerBox
                            title='수강신청 시작시간'
                            value={enrolmentBgnTime}
                            minMax={false}
                            onChangeTimeString={(timeString) => setEnrolmentBgnTime(timeString)}
                        />
                        <TimePickerBox
                            title='수강신청 종료시간'
                            value={enrolmentEndTime}
                            minMax={false}
                            onChangeTimeString={(timeString) => setEnrolmentEndTime(timeString)}
                        />
                    </div>
                    <div className='right-btn-box btn-wrap'>
                        <RedBorderButtonBox title='초기화' onClick={(e) => handleTimeInit()} />
                        <BlueBorderButtonBox title='저장' onClick={(e) => handleConfirm()} />
                    </div>
                </div>
            </div>
            <PopupRef ref={popupRef} />
        </>
    );
};

const NoticeArea = ({ mainUniversityCd }) => {
    const { semesterInfo, semesterId } = useSelector((state) => state.semesterEnrolmentManagementState);

    const [enrolmentNotice, setEnrolmentNotice] = useState('');

    const [noticeChecked, setNoticeChecked] = useState(false);

    const dispatch = useDispatch();

    const popupRef = useRef(null);

    useEffect(() => {
        setEnrolmentNotice(semesterInfo?.enrolmentNotice);
        setNoticeChecked(semesterInfo?.enrolmentNoticeStatusCd == 'ENABLED' ? true : false);
    }, [semesterInfo]);

    const handleConfirm = () => {
        dispatch(
            actionSaveNotice({
                params: {
                    semesterId,
                    mainUniversityCd,
                    enrolmentNotice,
                    enrolmentNoticeStatusCd: noticeChecked ? 'ENABLED' : 'DISABLED',
                },
                callback: () => {
                    popupRef.current.openInfo('수강신청 유의사항이 저장 되었습니다.', () => {
                        return function () {};
                    });
                },
            }),
        );
    };

    const onClickNoticeChecked = (e) => {
        setNoticeChecked(e.target.checked);
    };

    return (
        <>
            <div className='con-tb-wrap'>
                <div className='con-tb-title  '>
                    <h3>
                        대학별 수강신청 유의사항 관리{' '}
                        {semesterId &&
                            mainUniversityCd &&
                            `(${CodeUtil.getCodeName(
                                CODE_GROUP_ID.USER_UNIVERSITY,
                                mainUniversityCd,
                            )} , ${SemesterUtil.convertSemesterNm(semesterId)})`}
                    </h3>
                    <div className='btn-group'>
                        <>
                            <Switch
                                checked={noticeChecked}
                                onChange={(e) => onClickNoticeChecked(e)}
                                name='사용/미사용'
                                color='primary'
                            />
                        </>
                    </div>
                </div>
                <div className='comment-box'>
                    <ul>
                        <li>해당학기의 대학별 수강신청 유의사항 내용을 작성합니다.</li>
                        <li>
                            우측의 스위치 버튼을 이용하여 사용상태를 조정할 수 있습니다. 사용상태 변경 후 하단의 저장
                            버튼으로 상태를 저장하시기 바랍니다.
                        </li>
                    </ul>
                </div>
                {noticeChecked ? (
                    <TextEditor
                        className='cmnty-wrt-box mt16'
                        value={enrolmentNotice ? enrolmentNotice : ''}
                        onChange={setEnrolmentNotice}
                    />
                ) : (
                    <TextViewer
                        className='cmnty-wrt-box mt16'
                        value='대학별 수강신청 유의사항 미사용 상태입니다. 우측의 스위치 버튼을 사용상태(ON)로 변경 후 유의사항을 등록하세요.'
                    />
                )}
                <div className='right-btn-box btn-wrap'>
                    <BlueBorderButtonBox title='저장' onClick={(e) => handleConfirm(e)} />
                </div>
            </div>
            <PopupRef ref={popupRef} />
        </>
    );
};

const SemesterEnrolmentManagementView = () => {
    const mainUniversityCd = AuthenticationUtil.getUserUniversityCd();

    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='con-title-wrap conbg03'>
                    <h2 className='con-title'>{VIEW_SEMESTER_ENROLMENT_MANAGEMENT.title}</h2>
                    <p className='con-title-p'>{VIEW_SEMESTER_ENROLMENT_MANAGEMENT.subTitle}</p>
                </div>
                <div className='sub-nav-wrap '>
                    <div className='sub-nav-box'>
                        <BreadCrumb />
                    </div>
                </div>

                <ConditionArea mainUniversityCd={mainUniversityCd} />
                <TermArea mainUniversityCd={mainUniversityCd} />
                <NoticeArea mainUniversityCd={mainUniversityCd} />
            </div>
        </section>
    );
};

export default SemesterEnrolmentManagementView;
